import React, { useState } from 'react'
import { Checkbox } from 'antd'
import { useSnackbar } from 'notistack'
import Select from 'react-select'
// import { DatePicker } from '@atlaskit/datetime-picker'

import { usePet, useToggle, notifOps } from '../../modules'

import Modal from "../reusable/modal"
import Datepicker from "../reusable/datePicker"

import Permissions from './permissions'

const NewPatient = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [gender, setGender] = useState()
    const [dob, setDOB] = useState()
    const [age, setAge] = useState()
    const [county, setCounty] = useState()
    const [locality, setLocality] = useState()
    const [nokName, setNokName] = useState()
    const [nokPhone, setNokPhone] = useState()
    const [nokRShip, setNokRShip] = useState()
    const [beneficiaryCrId, setBeneficiaryCrId] = useState()
    const [documentType, setDocType] = useState({ label: 'National ID', value: 'National ID' })
    const [identification, setID] = useState()

    const [stations, setStations] = useState([])

    const [permissionsModal, togglePermissionsModal] = useToggle()
    const [birthday, toggleBirthday] = useToggle(true)

    const { enqueueSnackbar } = useSnackbar()

    const addPermission = station => {
        setStations([...stations, station])
    }

    const clear = () => {
        setName()
        setEmail()
        setPhone()
        setGender()
        setDOB()
        setAge()
        setCounty()
        setLocality()
        setNokName()
        setNokPhone()
        setNokRShip()
        setBeneficiaryCrId()
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'email':
                setEmail(e.target.value)
                break

            case 'phone':
                setPhone(e.target.value)
                break

            case 'age':
                setAge(e.target.value)
                break

            case 'locality':
                setLocality(e.target.value)
                break

            case 'nokName':
                setNokName(e.target.value)
                break

            case 'nokPhone':
                setNokPhone(e.target.value)
                break

            case 'nokRShip':
                setNokRShip(e.target.value)
                break

            case 'identification':
                setID(e.target.value)
                break

            case 'beneficiaryCrId':
                setBeneficiaryCrId(e.target.value)
                break

            default:
                break
        }
    }

    const changeBirthday = () => {
        toggleBirthday()
        setDOB()
        setAge(0)
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Patient has been added', ops('success'))

        setTimeout(() => {
            toggle()
            clear()
        }, 300)
    }

    const [{ loading }, addPatient] = usePet('newPatient', { 
        name, 
        gender: gender?.value, 
        dob, 
        age, 
        email, 
        phone, 
        county: county?.value, 
        locality, 
        nokName, 
        nokRShip, 
        nokPhone,
        beneficiaryCrId,
        documentType: documentType?.value,
        identification
    }, { notify: true, callback: onComplete, manual: true })

    let counties = [
        "Baringo",
        "Bomet",
        "Bungoma",
        "Busia",
        "Elgeyo-Marakwet",
        "Embu",
        "Garissa",
        "Homa Bay",
        "Isiolo",
        "Kajiado",
        "Kakamega",
        "Kericho",
        "Kiambu",
        "Kilifi",
        "Kirinyaga",
        "Kisii",
        "Kisumu",
        "Kitui",
        "Kwale",
        "Laikipia",
        "Lamu",
        "Machakos",
        "Makueni",
        "Mandera",
        "Marsabit",
        "Meru",
        "Migori",
        "Mombasa",
        "Murang'a",
        "Nairobi City",
        "Nakuru",
        "Nandi",
        "Narok",
        "Nyamira",
        "Nyandarua",
        "Nyeri",
        "Samburu",
        "Siaya",
        "Taita-Taveta",
        "Tana River",
        "Tharaka-Nithi",
        "Trans Nzoia",
        "Turkana",
        "Uasin Gishu",
        "Vihiga",
        "West Pokot",
        "Wajir"
    ]

    return (
        <Modal
            w="w-1/3"
            align="items-start"
            top="mt-10"
            bottom="pb-10"
            title="New Patient"
            toggle={toggle}
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <Permissions
                    onOk={addPermission}
                    visible={permissionsModal}
                    toggle={togglePermissionsModal} />
                <div>
                    <p className="font-bold my-3">Basic Information</p>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-3/5 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Name
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-name"
                                type="text"
                                value={name}
                                name="name"
                                placeholder="Evans Kimani" />
                        </div>
                        <div className="w-full md:w-2/5 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                                Gender
                            </label>
                            <Select
                                value={gender}
                                onChange={setGender}
                                options={['Male', 'Female'].map(item => ({ label: item, value: item }))}
                                placeholder="Select Gender" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full md:w-2/3 px-3 mb-3">
                            <Checkbox checked={birthday} onChange={ changeBirthday }>Patient Knows Birth Information</Checkbox>
                            {
                                birthday ?
                                <>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-email">
                                        Date of Birth
                                    </label>
                                    <Datepicker value={ dob } onChange={ setDOB } /> 
                                    {/* dateFormat="MM/DD/YYYY" value={dob} onChange={setDOB} /> */}
                                </>
                                :
                                <>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-email">
                                        Age
                                    </label>
                                    <input
                                        onChange={modify}
                                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                        id="grid-first-age"
                                        type="number"
                                        value={age}
                                        name="age"
                                        placeholder="Age in years" />
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div>
                    <p className="font-bold my-3">Identification Information</p>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                                Identification Type
                            </label>
                            <Select
                                value={documentType}
                                onChange={setDocType}
                                options={['National ID', 'Millitary ID'].map(item => ({ label: item, value: item }))}
                                placeholder="Select ID Type" />
                        </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-identification">
                                Identification No.
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-identification"
                                type="text"
                                value={identification}
                                name="identification"
                                placeholder="34XXXXXX" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-beneficiary-cr-id">
                                Beneficiary CR ID
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-beneficiary-cr-id"
                                type="text"
                                value={beneficiaryCrId}
                                name="beneficiaryCrId"
                                placeholder="CR-XXXXXXXX" />
                        </div>
                    </div>
                </div>
                <div>
                    <p className="font-bold my-3">Contact Information</p>
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                            <span>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Email <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                            </label>
                            </span>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-email"
                                type="email"
                                value={email}
                                name="email"
                                placeholder="user@email.com" />
                        </div>
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Phone
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-phone"
                                type="text"
                                value={phone}
                                name="phone"
                                placeholder="07XXXXXXXX" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-county">
                                County
                            </label>
                            <Select
                                value={county}
                                onChange={setCounty}
                                options={counties.map(item => ({ label: item, value: item }))}
                                placeholder="Select County" />
                        </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Locality
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-locality"
                                type="text"
                                value={locality}
                                name="locality"
                                placeholder="Kamangu" />
                        </div>
                    </div>
                </div>
                <div>
                    <p className="font-bold my-3">Next of Kin Information</p>
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                            <span>
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Name
                            </label>
                            </span>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-nokname"
                                type="text"
                                value={nokName}
                                name="nokName"
                                placeholder="Kamau Samuel" />
                        </div>
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Relationship
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-nokrship"
                                type="text"
                                value={nokRShip}
                                name="nokRShip"
                                placeholder="Relationship" />
                        </div>
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Phone
                            </label>
                            <input
                                onChange={modify}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-first-nokphone"
                                type="text"
                                value={nokPhone}
                                name="nokPhone"
                                placeholder="07XXXXXXXX" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button disabled={loading} onClick={ addPatient } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Add New Patient</button>
            </div>
        </Modal>
    )
}

export default NewPatient
